import React from "react";
import { createRoot } from "react-dom/client";
import { FloatingSubscribeButton } from "../components/email-subscription/floating-subscribe-button";
import { Cookie, CookieKeys } from "../util/cookie";

const isSubscribed = Cookie.get(CookieKeys.EmailSubscribed) == "true";

if (!isSubscribed) {
  const container = document.createElement("div");
  container.id = "floating-subscribe-button";

  const root = createRoot(container);
  root.render(<FloatingSubscribeButton />);

  document.body.appendChild(container);
}
